var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('v-head'),_vm._v(" "),_c('v-sidebar'),_vm._v(" "),_c('div',{staticClass:"content-box",class:{'content-collapse':_vm.collapse}},[_c('v-tags'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"move","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":_vm.tagsList}},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ceb21b8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Home.vue
// module id = null
// module chunks = 